/**
 * @generated SignedSource<<d2b2c12869ccfc5ac822532fb7d2461c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackCardActionsToggleReadUnreadMutation$variables = {
  id: string;
  value: boolean;
};
export type FeedbackCardActionsToggleReadUnreadMutation$data = {
  readonly feedbackToggleReadUnread: {
    readonly feedbackAndRequestsEdge: {
      readonly node: {
        readonly id?: string;
        readonly lastSeenByUser?: string | null;
      };
    };
  } | null;
};
export type FeedbackCardActionsToggleReadUnreadMutation = {
  response: FeedbackCardActionsToggleReadUnreadMutation$data;
  variables: FeedbackCardActionsToggleReadUnreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastSeenByUser",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "FeedbackNode",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "FeedbackRequestNode",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCardActionsToggleReadUnreadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FeedbackToggleReadUnread",
        "kind": "LinkedField",
        "name": "feedbackToggleReadUnread",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCardActionsToggleReadUnreadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FeedbackToggleReadUnread",
        "kind": "LinkedField",
        "name": "feedbackToggleReadUnread",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "66e29aa809d69233ec70753a645ea377",
    "id": null,
    "metadata": {},
    "name": "FeedbackCardActionsToggleReadUnreadMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackCardActionsToggleReadUnreadMutation(\n  $id: ID!\n  $value: Boolean!\n) {\n  feedbackToggleReadUnread(id: $id, value: $value) {\n    feedbackAndRequestsEdge {\n      node {\n        __typename\n        ... on FeedbackNode {\n          id\n          lastSeenByUser\n        }\n        ... on FeedbackRequestNode {\n          id\n          lastSeenByUser\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc171c9827a5ac836bd7e1659f0e41d1";

export default node;
